var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"target",staticClass:"base-card__w-full isolate z-40 w-full fixed bottom-0 left-0 bg-white shadow-xl ring-1 ring-black ring-opacity-5 overflow-hidden flex flex-col transition-all"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }